<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YMvNL5/tc-custom/9781617456749.jpg?1708745383246" alt="This image is the cover for the book Beaded Embroidery Stitching"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beaded Embroidery Stitching
      </h1>
      <p class="bookDescription body article font2">
        <b>Add dimension and luster to your projects—from sewing to jewelry making to mixed-media art—with tiny, shiny treasures. </b><br/><br/>Inspired by the magic of beads, buttons, and charms, experienced teacher Christen Brown shares eight stunning beadwork projects including brooches, bracelets, and wall hangings. <br/><br/>This helpful visual guide to 125 bead-embroidered and bead-woven stitches categorizes each stitch by style, with a second alphabetical index included—and the robust project gallery will inspire crafters of all skill levels, from embroiderers and sewists to crazy quilters, mixed-media artists, and jewelry makers.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christen Brown
      </h2>
      
      <p class="authorDescription body article">Christen Brown Bio: Christen Brown teaches embroidery, quilting, ribbonwork, mixed media, and beadwork in her best-selling books. With a degree in fashion design, she has shown her work in galleries and fashion shows all over the world. She lives in Escondido, California. christenbrown.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing, Inc.,
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f5a9ca8